const ToggleTheme = {
  CIRCLE: 'circle',
  PILL: 'pill'
};

export { ToggleTheme };
//# sourceMappingURL=ThemeTypes.js.map
